import { Theme } from '@mui/material/styles';
import { SwitchProps, switchClasses } from '@mui/material/Switch';

export function switches(theme: Theme) {
  // const lightMode = theme.palette.mode === 'light';

  const rootStyles = (ownerState: SwitchProps) => ({
    [`& .${switchClasses.thumb}`]: {
      boxShadow: 'none',
      color: theme.palette.blueBrand[0],
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
      opacity: 1,
      backgroundColor: theme.palette.blueBrand[400], // Cor do fundo da track no estado "checked"
    },
  });

  return {
    MuiSwitch: {
      styleOverrides: {
        root: ({ ownerState }: { ownerState: SwitchProps }) => rootStyles(ownerState),
      },
    },
  };
}
